import React, { useState } from "react";
import { Paperclip, Send } from "lucide-react";
import { toast } from "sonner";
import Reveal from "./Reveal";
import { BRAND } from "../mock";

export default function ContactForm() {
  const [form, setForm] = useState({
    name: "",
    company: "",
    phone: "",
    email: "",
    timeframe: "",
    message: "",
  });
  const [files, setFiles] = useState([]);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.phone || !form.email) {
      toast.error("Please fill in name, phone and email.");
      return;
    }
    // Persist locally as a demo only
    const all = JSON.parse(localStorage.getItem("emc_messages") || "[]");
    all.push({ ...form, files: files.map((f) => f.name), ts: new Date().toISOString() });
    localStorage.setItem("emc_messages", JSON.stringify(all));
    toast.success("Message sent! We’ll be in touch within one business day.");
    setForm({ name: "", company: "", phone: "", email: "", timeframe: "", message: "" });
    setFiles([]);
  };

  return (
    <section className="py-20 bg-[#0a0a0a] text-white" id="contact">
      <div className="max-w-6xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-5 gap-10">
        <Reveal className="lg:col-span-3">
          <span className="inline-block text-[11px] font-bold tracking-[0.25em] text-[#f5a623] mb-3">
            MESSAGE US
          </span>
          <h2 className="display-font text-4xl md:text-5xl font-bold mb-3">
            Let’s talk about your build.
          </h2>
          <p className="text-white/70 mb-8 max-w-lg">
            Tell us what you need — a one-off custom bracket or a full production run.
            We’ll come back same day with timing and a number.
          </p>

          <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <input className="emc-input md:col-span-2 px-4 py-3.5" placeholder="Name *" value={form.name} onChange={update("name")} />
            <input className="emc-input md:col-span-2 px-4 py-3.5" placeholder="Organization / Company Name" value={form.company} onChange={update("company")} />
            <input className="emc-input px-4 py-3.5" placeholder="Phone *" value={form.phone} onChange={update("phone")} />
            <input className="emc-input px-4 py-3.5" placeholder="Email *" type="email" value={form.email} onChange={update("email")} />
            <input className="emc-input md:col-span-2 px-4 py-3.5" placeholder="Job Completion Timeframe Request" value={form.timeframe} onChange={update("timeframe")} />
            <textarea className="emc-input md:col-span-2 px-4 py-3.5 min-h-[140px]" placeholder="Message" value={form.message} onChange={update("message")} />

            <label className="md:col-span-2 flex items-center justify-between border border-dashed border-[#2a2a2a] px-4 py-3 cursor-pointer hover:border-[#f5a623] transition-colors">
              <span className="flex items-center gap-2 text-sm text-white/80">
                <Paperclip className="w-4 h-4 text-[#f5a623]" /> Attach files (drawings, specs, photos)
              </span>
              <span className="text-xs text-white/50">Attachments ({files.length})</span>
              <input type="file" multiple className="hidden" onChange={(e) => setFiles(Array.from(e.target.files || []))} />
            </label>

            <button type="submit" className="md:col-span-2 btn-amber px-6 py-4 font-bold uppercase tracking-wider text-sm flex items-center justify-center gap-2">
              <Send className="w-4 h-4" /> Send Message
            </button>
            <p className="md:col-span-2 text-[11px] text-white/40">
              This site is protected by reCAPTCHA and the Google Privacy Policy and Terms of Service apply.
            </p>
          </form>
        </Reveal>

        <Reveal delay={150} className="lg:col-span-2">
          <div className="bg-[#111] border border-[#1f1f1f] p-7">
            <h3 className="display-font text-2xl font-bold mb-2">Questions or Concerns?</h3>
            <p className="text-white/70 mb-5">
              Need help selecting a product or a sustainable option? Send us a message — or just call.
            </p>
            <div className="space-y-1 text-sm text-white/80">
              <div className="font-bold text-white">{BRAND.fullName}</div>
              <div>{BRAND.address.line1}</div>
              <div>{BRAND.address.line2}</div>
              <div>{BRAND.address.country}</div>
              <a href={BRAND.phoneHref} className="block text-[#f5a623] font-bold mt-2">{BRAND.phone}</a>
            </div>
          </div>

          <div className="bg-[#f5a623] text-[#0a0a0a] p-7 mt-5">
            <h3 className="display-font text-2xl font-bold mb-3">Payment Methods</h3>
            <div className="flex flex-wrap items-center gap-3">
              {["VISA", "Mastercard", "Discover", "AmEx", "Net 30"].map((p) => (
                <span key={p} className="bg-white px-3 py-1.5 text-xs font-bold tracking-wider border border-[#0a0a0a]">{p}</span>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
